import { useOtpInput } from './use-otp-input'
import { OTP_BASE_CLASS, OTP_FILLED_CLASS } from './constants'

export function OtpInput({
  onChange,
  loading = false,
  preventAutoFocus = false,
}: {
  onChange: (code: string) => void
  loading?: boolean
  preventAutoFocus?: boolean
}) {
  const { digits, refs, handleChange, handleKeyDown, handlePaste } =
    useOtpInput({ onChange, loading })

  return (
    <div className="flex w-full gap-2">
      {digits.map((digit, i) => (
        <input
          key={i}
          ref={(el) => {
            if (el) refs.current[i] = el
          }}
          type="text"
          inputMode="numeric"
          value={digit}
          placeholder="-"
          disabled={loading}
          autoFocus={i === 0 && !preventAutoFocus}
          autoComplete={i === 0 ? 'one-time-code' : 'off'}
          autoCorrect="off"
          autoCapitalize="none"
          spellCheck={false}
          onChange={(e) => handleChange(i, e.target.value)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
          className={`border outline-none ${OTP_BASE_CLASS} ${digit ? OTP_FILLED_CLASS : ''}`}
        />
      ))}
    </div>
  )
}
